import { render } from "./AsahiLogoNew.vue?vue&type=template&id=fb02f2f8"
const script = {}

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__